<template>
  <div>
    <div v-if="isArray && isDoc">
      <FileItem v-for="file in value" :key="file.path" :file="file" disabled />
    </div>
    <div v-else>
      <span>{{ isArray ? 'Відсутнє' : value || '-' }}</span>
    </div>
  </div>
</template>

<script>
import FileItem from '@/components/filesUploader/FileItem.vue'
import { computed } from 'vue'

export default {
  name: 'HistoryItem',
  components: { FileItem },
  props: {
    value: { type: String, Number, Array, Object },
    arrowLine: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isArray = computed(() => Array.isArray(props.value))
    const isDoc = computed(() => {
      if (!isArray.value || !props.value.length) return false

      const firstValue = props.value[0]
      return (
        firstValue &&
        typeof firstValue === 'object' &&
        'size' in firstValue &&
        'path' in firstValue
      )
    })

    return { isArray, isDoc }
  },
}
</script>
